export const OWNER_ALL_USERS = 'all'

export function isSpecificOwner(userId: string | null | undefined): boolean {
  return userId != null && userId !== OWNER_ALL_USERS
}
